import axios from "axios";
import { newUrl } from "../../utility";
import { SET_FILTER_VALUES, SET_SEARCHDATA, SET_SELECTED_MAP_ICONS, SET_POI_MARKERS,SET_LOADER_STATE, ADD_SEARCHDATA,
     SET_SEARCHDATA_COUNT,SET_CURRENT_ROUTE ,SET_SIDE_BAR_OPEN, RESET_SEARCHDATA, FETCH_DISTINCT_BRANDS,RESET_POI } from "./types";

export const loadFilter = selectedFiletrValues => dispatch => {
	axios
		.post(
			newUrl + "/get_filter_values",
			{ selectedFiletrValues },
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			success => {
				// console.log(success.data);
				dispatch({
					type: SET_FILTER_VALUES,
					payload: success.data.result
                });
                
                dispatch({
                    type: SET_SEARCHDATA_COUNT,
                    payload: success.data.sites_count
                })

            
			},
			error => {
				console.log(error);
			}
		);
};

export const searchSites = selectedFiletrValues => dispatch => {
    dispatch({
        type: RESET_SEARCHDATA,
        payload: null
    });

    axios
        .post(
            newUrl + "/get_filter_data",
            { selectedFiletrValues },
            { headers: { authorization: localStorage.getItem("plano_token") } }
        )
        .then(
            success => {
                // console.log(success.data);
                dispatch({
                    type: SET_SEARCHDATA,
                    payload: success.data.result
                });
                dispatch({
                    type:SET_LOADER_STATE,
                    payload:false
                })
            },
            error => {
                console.log(error);
            }
        );
}




export const setSelectedMapIcons = (selectedMapIcons, selectedAreas) => dispatch => {
    dispatch({
        type: SET_SELECTED_MAP_ICONS,
        payload: selectedMapIcons
    });

    fetchAndSetPoi(selectedMapIcons, selectedAreas, dispatch);

}

let id;

export const fetchAndSetPoi = (selectedMapIcons, selectedAreas, dispatch) => {
    if (selectedMapIcons.length === 0) {
        return;
    }

    if (selectedAreas.length === 0) {
        return;
    }

    console.log("Calling Fetch And Set Poi");

    if (id) {
        clearTimeout(id);
    }

    let point_of_interest_markers = [];

    selectedMapIcons.map((a_item) => {
        selectedAreas.map((b_item) => {
            let place_type = a_item.value;
            let lat = b_item.getCenter().lat();
            let lng = b_item.getCenter().lng();
            let radius = b_item.getRadius();

            id = setTimeout(() => {
                axios.post(newUrl + "/getNearbyPlaces", { lat: lat, lng: lng, place_type: place_type, radius: radius }, { headers: { "authorization": localStorage.getItem("plano_token") } }).then((res, err) => {
                    if (err) {
                        console.log(err)
                    } else {
                        if (res.data) {
                            let data = res.data.data.results;
                            let sitesData = res.data.plano_inventory;
                            if (data) {
                                let temp_array = data.map(d_item => {
                                    let poi_item = {};
                                    poi_item.geometry = d_item.geometry;
                                    poi_item.name = d_item.name;
                                    poi_item.icon = d_item.icon;
                                    return poi_item;
                                });

                                point_of_interest_markers = [...point_of_interest_markers, ...temp_array];

                                dispatch({
                                    type: SET_POI_MARKERS,
                                    payload: point_of_interest_markers
                                });
                                dispatch({
                                    type: SET_SEARCHDATA,
                                    payload: sitesData
                                });
                               
                            }
                        }
                    }
                })
            }, 2000);

            return null;
        })

        return null;
    })
}


export const fetchCustomPoiData = ( filterVals,nearbyVals) => dispatch => {
    axios.post(newUrl + "/getCustomNearbyData", { filterVals:filterVals,  nearbyVals:nearbyVals }, { headers: { "authorization": localStorage.getItem("plano_token") } }).then((res, err) => {
        if (err) {
            console.log(err)
        } else {
            if (res.data) {
                let point_of_interest_markers = [];
                let data = res.data.data.results;
                let sitesData = res.data.plano_inventory;
                if (data) {
                    let temp_array = data.map(d_item => {
                        let poi_item = {};
                        poi_item.geometry = d_item.geometry;
                        poi_item.name = d_item.name;
                        poi_item.icon = d_item.icon;
                        return poi_item;
                    });

                    point_of_interest_markers = [...point_of_interest_markers, ...temp_array];
                    changeLoaderStatus(false);
                    dispatch({
                        type: SET_POI_MARKERS,
                        payload: point_of_interest_markers
                    });
                    // dispatch({
                    //     type: SET_SEARCHDATA,
                    //     payload: sitesData
                    // });
                    dispatch({
                        type:SET_LOADER_STATE,
                        payload:false
                    })
                }
            }
        }
    })
}


export const resetPoiData = () => dispatch => {
        dispatch({type:RESET_POI})
        console.log("gola")
}


export const fetchCompetitionData = ( filterVals,compVals) => dispatch => {
    axios.post(newUrl + "/fetchCompetitionData", { filterVals:filterVals,  compVals:compVals }, { headers: { "authorization": localStorage.getItem("plano_token") } }).then((res, err) => {
        if (err) {
            console.log(err)
        } else {
            if (res.data) {
                // let point_of_interest_markers = [];
                // let data = res.data.data.results;
                let sitesData = res.data.plano_inventory;
                if (sitesData) {
                   
                    dispatch({
                        type: ADD_SEARCHDATA,
                        payload: sitesData
                    });
                    dispatch({
                        type:SET_LOADER_STATE,
                        payload:false
                    })
                }
            }
        }
    })
}


export const fetchDistinctBrands = ( filterVals) => dispatch => {
    axios.post(newUrl + "/fetchDistinctBrands", { filterVals:filterVals }, { headers: { "authorization": localStorage.getItem("plano_token") } }).then((res, err) => {
        if (err) {
            console.log(err)
        } else {
            if (res.data) {

                let distinctBrands = res.data.proper_brands;
                dispatch({
                    type: FETCH_DISTINCT_BRANDS,
                    payload: distinctBrands
                });
            }
        }
    })
}

export const changeLoaderStatus = state => dispatch => {
    console.log('incoming',state)
    dispatch({
        type:SET_LOADER_STATE,
        payload:state
    })
} 


export const loadCampaignMap = (routeName,campaignName) => dispatch => {

    dispatch({
        type: RESET_SEARCHDATA,
        payload : null
    })

    dispatch({
        type: SET_CURRENT_ROUTE,
        payload : routeName
    })

    dispatch({
        type: SET_SIDE_BAR_OPEN,
        payload: false
    })


    axios
    .post(
        newUrl + "/getPlanoCampaignSites",
        { campaignName },
        { headers: { authorization: localStorage.getItem("plano_token") } }
    )
    .then(
        success => {
            console.log('hola',success.data);
            dispatch({
                type: SET_SEARCHDATA,
                payload: success.data.result
            });
            let point_of_interest_markers = [];
            let data = success.data.nearby_places;

            if (data) {
                let temp_array = data.map(d_item => {
                    let poi_item = {};
                    poi_item.geometry = d_item.geometry;
                    poi_item.name = d_item.name;
                    poi_item.icon = d_item.icon;
                    return poi_item;
                });

                point_of_interest_markers = [...point_of_interest_markers, ...temp_array];
                changeLoaderStatus(false);
                dispatch({
                    type: SET_POI_MARKERS,
                    payload: point_of_interest_markers
                });
            }

            dispatch({
                type:SET_LOADER_STATE,
                payload:false
            })

    
        },
        error => {
            console.log(error);
        }
    );
}





// WEBPACK FOOTER //
// ./src/v3/actions/filterActions.js